import React from "react";

const priorities = [
  "Increase waste reduction and recycling (save forest initiatives)",
  "Improve supply chain ethics and transparency (reduce use of paper)",
  "Reducing carbon foot prints (Reduce use of wood fuel)",
  "Collaborating with external partners (Organizations with conservation initiatives)",
  "ESG Compliance",
  "Implementing circular economy practices",
];

const percentages = [
  ["56%", "95%", "100%", "100%", "85%", "99%"],
  ["56%", "95%", "100%", "100%", "85%", "99%"],
  ["56%", "95%", "100%", "100%", "85%" , "99%"],
  
];

const colors = ["#83C543", "#5C9247", "#114918"];
const sectionTitles = ["| Crops", "| Livestock", "| Communities"];

const SustainabilityPriorities = () => {
  return (
    <div className="">
      <div className="flex justify-between items-center md:mt-8 mt-3">
        <h2 className="text-[10px] md:text-[36px] font-bold text-[#FDBD26]">
          IMPACT
        </h2>
        <div className="flex md:space-x-6">
          <div className="flex items-center flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
            <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[245px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
              RUN REPORT
            </p>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[13px] md:hidden flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
            />
          </div>
        </div>
      </div>

      <p className="text-[7px] md:text-[24px] font-bold text-black mt-2 text-left">
        Sustainability priorities (% top / high priorities)
      </p>

      <div className=" flex  md:flex-row gap-2 items-start w-full md:mt-0 mt-2">
        {/* Labels */}
        <div className="flex flex-col md:space-y-1.5 space-y-[2px] md:w-1/4 mt-4 md:mt-8">
          {priorities.map((item, index) => {
            const match = item.match(/^(.*?)\s*(\((.*?)\))?$/);
            const mainText = match?.[1] || "";
            const bracketText = match?.[3] || "";

            return (
              <div
                key={index}
                className="w-full h-[15px] md:h-[51px]   bg-[#F3F5F5] rounded-md md:px-3 px-1  text-black text-[4px] md:text-[14px] md:py-1 leading-snug"
              >
                <strong className="font-extrabold">{mainText.trim()}</strong>
                {bracketText && (
                  <span className="font-normal leading-tight italic"> ({bracketText})</span>
                )}
              </div>
            );
          })}
        </div>

        {/* Percentage Columns */}
        <div className="flex md:flex-row gap-2 w-full md:w-3/4 ">
          {percentages.map((column, columnIndex) => (
            <div key={columnIndex} className="flex flex-col md:space-y-1.5 space-y-[2px]  w-[80px] md:w-1/3">
              <h3 className="text-[7px] md:text-[20px] font-bold md:-mb-2" style={{ color: colors[columnIndex] }}>
                {sectionTitles[columnIndex]}
              </h3>
              {column.map((percentage, rowIndex) => (
                <div
                  key={rowIndex}
                  className="h-[15px] md:h-[51px] flex items-center justify-start text-white font-semibold text-[5px] md:text-[20px] rounded-r-[5px] md:px-2 px-1"
                  style={{ width: percentage, backgroundColor: colors[columnIndex] }}
                >
                  {percentage}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

     
    </div>
  );
};

export default SustainabilityPriorities;
